webpackJsonp([1],{

/***/ "/0NQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      faqs: [['チーム統一のユニフォームが無いのですが、参加できますか？', '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'], ['大会の予約はいつからできますか？', '大会によって異なるのですが、概ね3か月前から大会当日までとなります。参加チーム枠もありますので、ご連絡ください。'], ['チーム統一のユニフォームが無いのですが、参加できますか？', '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'], ['当日の持ち物をお教えください。', '大会当日は運動できる服装と内履きをご持参ください。当大会ではビブの貸出、ボールの貸出を行っております。ご気軽にご参加ください。'], ['1チーム何名まで参加できますか？', '何名でも可能です。過去に最大で20名で参加されたチームがありました。'], ['5人以下で参加できますか？', 'チームにて参加をいただいているのでご遠慮お願いします。ただし、個人参加大会も行っているので、そちらをご検討ください。'], ['当日、人数が揃わない場合、棄権になってしまいますか？', '1名2名の欠員であれば当運営メンバーが代行します。また、大会責任者へご相談いただければ、他チームからの助っ人を募集いたします。'], ['審判やオフィシャルが出来ないのですが、参加してもいいですか？', '審判、オフィシャルは当大会運営部で行います。ご気軽にご参加ください。'], ['ケガをした時の対応について教えてください。', '基本的に怪我は自己責任となります。怪我の責任は一切負いかねます。各自、スポーツ保険に加入されることをお勧めします。'], ['領収書の発行をお願いできますか？', '可能です。当日、お申し出ください。'], ['同一大会に2チームエントリーしたいのですが、可能でしょうか？', '可能です。ただし、皆さんに楽しんでもらうために4チームに同時エントリーはご遠慮いただいております。'], ['ハーフではなくクオーターで試合はできませんか？', '当大会は、多くのチームと試合を行う事で、すべてのチームがエンジョイできる大会を目指しています。クオーター大会も行っていますが、基本はハーフとなります。'], ['大会の中止はありますか？', '当運営部の要因で中止した事はありませんが、交通事情にて予定参加チームが欠席したケースはございます。その場合、予定チーム数の半分以上が欠席の場合、予定とは異なった大会を行わせていただきます。'], ['学生（20歳以下）が参加できる大会はありますか？', '保護者の許可があれば参加可能ですが、代表者様もしくは引率の方は20歳以上とさせてください。'], ['練習試合を企画しているのですが、協力いただくことは可能でしょうか？', 'もちろんできる限り協力させていただきますが、ご希望にそぐわない場合もございますので、概要と当大会運営部が行う事をメールにてご連絡ください。']]
    };
  }
});

/***/ }),

/***/ "/MPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('div',{attrs:{"id":"firebaseui-auth-container"}},[_c('p',{attrs:{"id":"leadmsg"}},[_vm._v("友達とチームを作ってバスケをしよう")])]),_vm._v(" "),_c('div',{attrs:{"id":"loader"}},[_vm._v("Loading...")]),_vm._v(" "),_c('p',{attrs:{"id":"termmessage"}},[_vm._v("ログインすることで、あなたはACTIVE HOOPの\n          "),_c('router-link',{attrs:{"to":"/terms","target":"_blank"}},[_vm._v("利用規約")]),_vm._v("、\n          "),_c('router-link',{attrs:{"to":"/privacypolicy","target":"_blank"}},[_vm._v("プライバシーポリシー")]),_vm._v("\n          に同意したことになります。")],1)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/YSH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = LineIt;

/***/ }),

/***/ "0PBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__("BRNQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_877380c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__("/MPm");
function injectStyle (ssrContext) {
  __webpack_require__("hrrE")
  __webpack_require__("mrXD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_877380c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1IaW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sendgrid_vue__ = __webpack_require__("p32l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a9ffee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sendgrid_vue__ = __webpack_require__("ayse");
function injectStyle (ssrContext) {
  __webpack_require__("4ibj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sendgrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a9ffee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sendgrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1TMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("エントリーが確定しました")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("\n          後日、確認のEメールを送信いたします。\n        ")])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin":"25px 0px"}},[_vm._v("予約ID："+_vm._s(_vm.item.id))]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/schedule"}},[_vm._v("エントリー済大会一覧へ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Tl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "1XKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  title: function title() {
    return '大会詳細';
    // this.item.title
  },

  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a
  },
  data: function data() {
    return {
      // title: this.item.title,
      defaultTeamAvatar: '/static/defaultteam.png',
      teams: [{ header: '参加チーム' }],
      // remaining: this.item.capacity - this.teams.length,
      item: Object,
      to: '/user/profile',
      cancelto: null,
      joiningTemas: [],
      isEntry: false
    };
  },
  created: function created() {
    var _this = this;

    // select tournament
    var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();

    var docRef = db.collection('tournaments').doc(this.$route.params.id);
    // Read the document.
    docRef.get().then(function (doc) {
      if (doc.exists) {
        // Document read successfully.
        _this.item = doc.data();
        _this.entries();
      } else {
        console.log('No such document!');
      }
    }).catch(function (error) {
      console.log('Error getting document:', error);
    });
    //

    // this.remaining = this.item.capacity - this.teams.length
  },

  methods: {
    update: function update() {
      //
      this.email = null;
    },

    init: function init() {
      //      var db = firebase.firestore()
    },

    entries: function entries() {
      var _this2 = this;

      var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
      this.getTeamByUser();
      var query = db.collection('entries').where('tournament', '==', this.$route.params.id);
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (documentSnapshot) {
          var obj = documentSnapshot.data();
          _this2.getTeam(obj.team).then(function (doc2) {
            if (doc2) {
              obj.teamName = doc2.teamName;
              _this2.teams.push(obj);
              // is entry
              if (_this2.joiningTemas.includes(obj.team)) {
                _this2.isEntry = true;
              }
            }
          });
        });
      });
    },
    tournaments: function tournaments() {
      var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
      db.collection('tournaments').get();
    },
    getTeam: function getTeam(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //
        var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
        var docRef = db.collection('teams').doc(id);

        // Read the document.
        docRef.get().then(function (doc) {
          if (doc.exists) {
            // Document read successfully.
            resolve(doc.data());
          } else {
            console.log('No such document!');
          }
        }).catch(function (error) {
          console.log('Error getting document:', error);
        });
        //
      });
    },
    getTeamByUser: function getTeamByUser() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //
        var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
        if (!user) {
          return;
        }
        var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
        var query = db.collection('m2m_teams_users').where('user', '==', user.uid);
        // Read the document.
        query.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (documentSnapshot) {
            var obj = documentSnapshot.data();
            if (obj) {
              _this3.joiningTemas.push(obj.team);
              _this3.to = '/tournamentconfirm/' + _this3.$route.params.id;
            }
          });
        });
        //
      });
    }
  }
});

/***/ }),

/***/ "25wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("招待状を送りましょう")]),_vm._v(" "),_c('p',[_vm._v("友達にチームへの招待状を送って、メンバー追加しましょう。")])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"line-it-button",staticStyle:{"display":"none"},attrs:{"id":"sendline-btn","data-lang":"ja","data-type":"share-a","data-url":_vm.customurl}})]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","secondary":"","green":""},on:{"click":function($event){_vm.sendmail()}}},[_vm._v("メールで送る")]),_vm._v(" "),_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('div',{staticClass:"fb-send",attrs:{"data-href":"https://www.your-domain.com/your-page.html","data-layout":"button_count"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2HMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__("3VHS");
// Initialize Cloud Firestore through Firebase

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_2_firebase___default.a
  },
  data: function data() {
    return {
      valid: true,
      teamNameeRules: [function (v) {
        return !!v || 'Name is required';
      }],
      url: '',
      teamName: 'any',
      photoURL: '',
      teamInfo: null,
      name: '',
      items: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県'],
      teamObj: {},
      to: '/team/' + this.$route.params.id + '/members',
      isRegist: false,
      // user: firebase.auth().currentUser,
      defaultTeamAvatar: '/static/defaultteam.png'
    };
  },
  created: function created() {
    // select teams

    if (this.$route.params.id !== 'regist') {
      console.log(this.$route.params.id);
      this.isRegist = false;
    }

    this.getTeam();
    //
  },

  methods: {
    create: function create() {
      console.log('create');
      var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
      var uid = this.user.uid;
      db.collection('teams').add(this.teamObj).then(function (docRef) {
        console.log('Document successfully written!');
        // m2m
        var m2mObj = { role: 'ADMIN', team: docRef.id, user: uid };
        db.collection('m2m_teams_users').add(m2mObj).then(function () {
          console.log('Document successfully written!');
        });
      });
      this.$router.push('/tournament');
    },
    update: function update() {
      console.log(this.teamName);
      //
      // firestore
      var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
      var docRef = db.collection('teams').doc(this.$route.params.id);

      docRef.update(this.teamObj).then(function () {
        console.log('Document successfully updated!');
      }).catch(function (error) {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error);
      });
      this.$router.push('/tournament');
    },
    // duplicate
    getTeam: function getTeam() {
      var _this = this;

      console.log(this.teamName);
      var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
      var docRef = db.collection('teams').doc(this.$route.params.id);

      // Read the document.
      docRef.get().then(function (doc) {
        if (doc.exists) {
          // Document read successfully.
          _this.teamObj = doc.data();
          _this.isRegist = true;
          console.log('this->' + _this.teamObj.teamName);
        } else {
          console.log('No such document!');
        }
      }).catch(function (error) {
        console.log('Error getting document:', error);
      });
    },
    move: function move() {
      this.$router.push('/user/profile');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    user: 'user'
  }))
});

/***/ }),

/***/ "4ibj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5A05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
  },
  data: function data() {
    return {
      item: Object
    };
  },
  created: function created() {
    this.entry();
  },

  methods: {
    entry: function entry() {
      var _this = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

      // entries
      var docRef = db.collection('entries').doc(this.$route.params.id);

      // Read the document.
      docRef.get().then(function (doc) {
        if (doc.exists) {
          // Document read successfully.
          _this.item = doc.data();
          _this.item.id = doc.id;
          console.log(_this.item);
        } else {
          console.log('No such document!');
        }
      }).catch(function (error) {
        console.log('Error getting document:', error);
      });
    }
  }
});

/***/ }),

/***/ "6EEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentCancel_vue__ = __webpack_require__("Ekof");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0357f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentCancel_vue__ = __webpack_require__("ypDj");
function injectStyle (ssrContext) {
  __webpack_require__("/YSH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentCancel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0357f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentCancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-avatar',{attrs:{"size":"40px"}},[_c('img',{attrs:{"src":_vm.photoURL,"alt":"avatar"}})]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.teamObj.teamName))])])],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [(item.header)?_c('v-subheader',{domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":"","download":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2)],1),_vm._v(" "),_c('v-btn',{attrs:{"to":this.to}},[_vm._v("メンバーを追加")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6iaR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7vb3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8c0z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('p',[_vm._v("下の「エントリーを確定する」ボタンを押してエントリーいただくことで、お客様は当サイトのプライバシー規約及び利用規約に同意の上、大会にエントリーされたことになります。")]),_vm._v(" "),(_vm.item.remaining > 0)?_c('v-btn',{attrs:{"block":"","error":""},on:{"click":_vm.entry}},[_vm._v("エントリーを確定する")]):(_vm.item.remaining == 0)?_c('div',{staticClass:"red--text"},[_vm._v("満員です")]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',[_c('h4',{staticClass:"headline"},[_vm._v("エントリー内容")])])]),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("event")]),_vm._v("\n"+_vm._s(_vm._f("dateformat")(_vm.item.startTime)))],1),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("location_on")]),_vm._v("\n"+_vm._s(_vm.item.location)+"\n")],1),_vm._v(" "),_c('p',[_vm._v("\nチーム\n"),_c('v-select',{attrs:{"items":_vm.items,"label":"Select","single-line":"","item-text":"label","item-value":"value","return-object":""},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})],1),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("payment")]),_vm._v("\n参加費 ¥ "+_vm._s(_vm.item.entryFee)+"/チーム\n")],1),_vm._v(" "),_c('v-divider'),_vm._v("\nご請求額："),(_vm.item.entryFee)?_c('span',{staticClass:"price"},[_vm._v("¥ "+_vm._s(this.item.entryFee.toLocaleString()))]):_vm._e(),_vm._v(" "),_c('div',[_c('h4',{staticClass:"headline mt-4"},[_vm._v("支払い方法")])]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.payMethod),callback:function ($$v) {_vm.payMethod=$$v},expression:"payMethod"}},[_c('v-radio',{attrs:{"label":"現地払い","value":"ON-SITE"}})],1)],1)],1),_vm._v(" "),(_vm.item.remaining > 0)?_c('v-btn',{attrs:{"block":"","error":""},on:{"click":_vm.entry}},[_vm._v("エントリーを確定する")]):(_vm.item.remaining == 0)?_c('div',{staticClass:"red--text"},[_vm._v("満員です")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9dS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('h4',[_vm._v("参加予定の大会")]),_vm._v(" "),(_vm.items.size==0)?_c('span',{staticClass:"subheading orange--text"},[_c('hr',{staticClass:"divider my-5"}),_vm._v("\n        大会にエントリーしてください。\n        "),_c('hr',{staticClass:"divider my-5"})]):_vm._e()])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [_c('v-card',{staticClass:"mb-3",attrs:{"to":item.to}},[_c('v-card-media',{staticClass:"white--text",class:'colorfilter-' + item.category,attrs:{"height":"200px","src":"/static/carousel/1.JPG"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-center":"","flexbox":""}},[_c('div',{staticClass:"ah-tournament-card"},[_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("dateformat")(item.startTime)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(item.subTitle))])]),_vm._v(" "),_c('span',{staticClass:"display-1"})])],1)],1)],1)],1)]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9nvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ar7I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B7i1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui__ = __webpack_require__("2ahc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebaseui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uiConfig = {
  signInSuccessUrl: '/#/',
  callbacks: {
    signInSuccess: function signInSuccess(currentUser, credential, redirectUrl) {
      console.log('redirectUrl->', redirectUrl);
      // firestore
      var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
      db.collection('users').doc(currentUser.uid).set({
        name: currentUser.displayName,
        email: currentUser.email,
        photoURL: currentUser.photoURL,
        time: new Date().getTime()
      }).then(function (docRef) {
        console.log('Document written with ID: ', docRef.id);
      }).catch(function (error) {
        console.error('Error adding document: ', error);
      });

      return true;
    },
    uiShown: function uiShown() {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById('loader').style.display = 'none';
    }
  },
  credentialHelper: __WEBPACK_IMPORTED_MODULE_3_firebaseui___default.a.auth.CredentialHelper.NONE,
  signInOptions: [
  // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
  // firebase.auth.GithubAuthProvider.PROVIDER_ID,
  __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.EmailAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.FacebookAuthProvider.PROVIDER_ID],
  tosUrl: '/#tos'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    fbUiApp: 'fbUiApp'
  })),
  mounted: function mounted() {
    this.fbUiApp.start('#firebaseui-auth-container', uiConfig);
  },
  destroyed: function destroyed() {
    this.fbUiApp.reset();
  }
});

/***/ }),

/***/ "Bf80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("運営団体について")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('p',{staticClass:"ah-regal-head",staticStyle:{"margin-bottom":"20px","font-size":"16px"}},[_vm._v("\nアマチュア向けバスケットボール大会を運営\n")]),_vm._v(" "),_c('p',[_vm._v("\n\nいつものチームの気心知れた仲間と、普段は敵同士のアイツやあの子と新しいチームでエンジョイバスケ！"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n一般大会以外にも、同窓会、OB会、会社対抗などこんなバスケがやってみたい！というものはお気軽にお声がけください。"),_c('br'),_vm._v("\nその他、大会に出たことがないチームへのコーチ派遣や各種スクールも計画中！"),_c('br'),_c('br'),_vm._v("\nACTIVE HOOP はバスケが大好きな人の味方です！\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n運営団体\n")]),_vm._v(" "),_c('p',[_vm._v("\n   ActiveForce\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n所在地\n")]),_vm._v(" "),_c('p',[_vm._v("\n東京都豊島区南池袋２−８−１７　第一豊南ビル６階（株）ワイズパートナーズ内\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n連絡先\n")]),_vm._v(" "),_c('p',[_vm._v("\n03-5396-7425"),_c('br'),_vm._v("\ninfo@ac4th.com\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n代表\n")]),_vm._v(" "),_c('p',[_vm._v("\n高橋 旭\n")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bfkr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentDetail_vue__ = __webpack_require__("1XKP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45951b79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentDetail_vue__ = __webpack_require__("WTWi");
function injectStyle (ssrContext) {
  __webpack_require__("lT2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45951b79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D9pK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ header: 'Members'
        // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Brunch this weekend?', subtitle: "<span class='grey--text text--darken-2'>Ali Connors</span> — I'll be in your neighborhood doing errands this weekend. Do you want to hang out?" },
        // { divider: true, inset: true },
        // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>', subtitle: "<span class='grey--text text--darken-2'>to Alex, Scott, Jennifer</span> — Wish I could come, but I'm out of town this weekend." },
        // { divider: true, inset: true },
        // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Oui oui', subtitle: "<span class='grey--text text--darken-2'>Sandra Adams</span> — Do you have Paris recommendations? Have you ever been?" }
      }],
      teamObj: {},
      to: '/team/' + this.$route.params.id + '/invite'
    };
  },
  created: function created() {
    this.entries();
    this.getTeam();
    // console.log(this.item.capacity, '<- capacity | length ->', this.teams.length)
    // this.remaining = this.item.capacity - this.teams.length
  },

  methods: {
    entries: function entries() {
      var _this = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      console.log(this.$route.params.id);
      var query = db.collection('m2m_teams_users').where('team', '==', this.$route.params.id);
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (documentSnapshot) {
          var obj = documentSnapshot.data();
          // user
          var docRef = db.collection('users').doc(obj.user);
          docRef.get().then(function (doc) {
            if (doc.exists) {
              // Document read successfully.
              // this.items.push(doc.data())
              var user = doc.data();
              _this.items.push({ avatar: user.photoURL, title: user.name, subtitle: '', to: '' });
              console.log('inner');
            } else {
              console.log('No such document!');
            }
          }).catch(function (error) {
            console.log('Error getting document:', error);
          });
          console.log(obj);
          console.log(docRef);
        });
      });
      console.log('------');
    },
    getTeam: function getTeam() {
      var _this2 = this;

      console.log('id->' + this.$route.params.id);
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      var docRef = db.collection('teams').doc(this.$route.params.id);

      // Read the document.
      docRef.get().then(function (doc) {
        if (doc.exists) {
          // Document read successfully.
          _this2.teamObj = doc.data();
          console.log('this->' + _this2.teamObj.teamName);
        } else {
          console.log('No such document!');
        }
      }).catch(function (error) {
        console.log('Error getting document:', error);
      });
    }
  }
});

/***/ }),

/***/ "EMFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("gjb/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1075baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("Q4/H");
function injectStyle (ssrContext) {
  __webpack_require__("cAxy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1075baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EfMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("ご利用規約")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('p',[_vm._v("\n   この利用規約（以下，「本規約」といいます。）は，Active Force（以下，「当社」といいます。）がこのウェブサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。 登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第1条（適用）\n")]),_vm._v(" "),_c('p',[_vm._v("\n本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第2条（利用登録）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    登録希望者が当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。\n    当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。"),_c('br'),_c('br'),_vm._v("\n        （1）利用登録の申請に際して虚偽の事項を届け出た場合"),_c('br'),_vm._v("\n        （2）本規約に違反したことがある者からの申請である場合"),_c('br'),_vm._v("\n        （3）その他，当社が利用登録を相当でないと判断した場合\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第3条（ユーザーIDおよびパスワードの管理）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを管理するものとします。\n    ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。 当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第4条（利用料金および支払方法）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    ユーザーは，本サービス利用の対価として，当社が別途定め，本ウェブサイトに表示する利用料金を，当社が指定する方法により支払うものとします。\n    ユーザーが利用料金の支払を遅滞した場合には，ユーザーは年１４．６％の割合による遅延損害金を支払うものとします。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第5条（禁止事項）\n")]),_vm._v(" "),_c('p',[_vm._v("\nユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。"),_c('br')]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("法令または公序良俗に違反する行為")]),_vm._v(" "),_c('li',[_vm._v("犯罪行為に関連する行為")]),_vm._v(" "),_c('li',[_vm._v("当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為")]),_vm._v(" "),_c('li',[_vm._v("当社のサービスの運営を妨害するおそれのある行為")]),_vm._v(" "),_c('li',[_vm._v("他のユーザーに関する個人情報等を収集または蓄積する行為")]),_vm._v(" "),_c('li',[_vm._v("他のユーザーに成りすます行為")]),_vm._v(" "),_c('li',[_vm._v("当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為")]),_vm._v(" "),_c('li',[_vm._v("その他，当社が不適切と判断する行為")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第6条（本サービスの提供の停止等）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。"),_c('br'),_vm._v("\n        （1）本サービスにかかるコンピュータシステムの保守点検または更新を行う場合"),_c('br'),_vm._v("\n        （2）地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合"),_c('br'),_vm._v("\n        （3）コンピュータまたは通信回線等が事故により停止した場合"),_c('br'),_vm._v("\n        （4）その他，当社が本サービスの提供が困難と判断した場合"),_c('br'),_vm._v("\n    当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。"),_c('br')]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第7条（利用制限および登録抹消）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    当社は，以下の場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。"),_c('br'),_vm._v("\n        （1）本規約のいずれかの条項に違反した場合"),_c('br'),_vm._v("\n        （2）登録事項に虚偽の事実があることが判明した場合"),_c('br'),_vm._v("\n        （3）その他，当社が本サービスの利用を適当でないと判断した場合"),_c('br'),_vm._v("\n    当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第8条（免責事項）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    当社の債務不履行責任は，当社の故意または重過失によらない場合には免責されるものとします。"),_c('br'),_vm._v("\n    当社は，何らかの理由によって責任を負う場合にも，通常生じうる損害の範囲内かつ有料サービスにおいては 代金額（継続的サービスの場合には1か月分相当額）の範囲内においてのみ賠償の責任を負うものとします。"),_c('br'),_vm._v("\n    当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第9条（サービス内容の変更等）\n")]),_vm._v(" "),_c('p',[_vm._v("\n当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第10条（利用規約の変更）\n")]),_vm._v(" "),_c('p',[_vm._v("\n当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第11条（通知または連絡）\n")]),_vm._v(" "),_c('p',[_vm._v("\nユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第12条（権利義務の譲渡の禁止）\n")]),_vm._v(" "),_c('p',[_vm._v("\nユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。\n")]),_vm._v(" "),_c('p',{staticClass:"ah-regal-head"},[_vm._v("\n第13条（準拠法・裁判管轄）\n")]),_vm._v(" "),_c('p',[_vm._v("\n    本規約の解釈にあたっては，日本法を準拠法とします。"),_c('br'),_vm._v("\n    本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。\n")]),_vm._v(" "),_c('p',[_vm._v("2018年2月1日制定")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ekof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
  },
  data: function data() {
    return {
      payMethod: 'ON-SITE',
      item: { location: null },
      items: [],
      to: null,
      team: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth?' + _this.$route.params.id;
      } else {
        // サインイン済み
      }
    });

    // select tournament
    var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
    var docRef = db.collection('tournaments').doc(this.$route.params.id);

    // Read the document.
    docRef.get().then(function (doc) {
      if (doc.exists) {
        // Document read successfully.
        _this.item = doc.data();
        _this.to = '/tournamentconfirm/' + _this.$route.params.id;
      } else {
        console.log('No such document!');
      }
    }).catch(function (error) {
      console.log('Error getting document:', error);
    });
    this.init();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      console.log(this.$route.params.id);
      var query = db.collection('m2m_teams_users').where('user', '==', __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid) // TODO
      .where('role', '==', 'ADMIN');
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (documentSnapshot) {
          var obj = documentSnapshot.data();
          // user
          var docRef = db.collection('teams').doc(obj.team);
          docRef.get().then(function (doc) {
            if (doc.exists) {
              _this2.items.push({ label: doc.data().teamName, value: doc.id });
              _this2.team = doc.id;
            } else {
              console.log('No such document!');
            }
          }).catch(function (error) {
            console.log('Error getting document:', error);
          });
        });
      });
    },

    cancel: function cancel() {
      var _this3 = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      var id = this.$route.params.id + this.team.value; // TODO
      console.log('doentry', this.team);
      console.log('doentry', this.$route.params.id);
      console.log('doentry', this.payMethod);
      var document = db.collection('entries').doc(id); // + this.$route.params.id)
      //
      document.set({
        team: this.team,
        tournament: this.$route.params.id,
        payMethod: this.payMethod,
        time: null
      }).then(function () {
        // Document created successfully.
        _this3.$router.push('/tournamententered/' + id);
      });
    }
  }
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// (function (d, s, id) {
//   var js = d.getElementsByTagName(s)[0]
//   var fjs = d.getElementsByTagName(s)[0]
//   if (d.getElementById(id)) return
//   js = d.createElement(s); js.id = id
//   js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.0&appId=486539015038903&autoLogAppEvents=1'
//   fjs.parentNode.insertBefore(js, fjs)
// }(document, 'script', 'facebook-jssdk'))

/***/ }),

/***/ "JNHC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LBmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__ = __webpack_require__("MQaZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2f4fc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__ = __webpack_require__("YEqU");
function injectStyle (ssrContext) {
  __webpack_require__("NTGm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2f4fc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LFbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
  },
  data: function data() {
    var user = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;
    if (user) {
      // User is signed in.
      // displayName = (user.displayName)
      // photoURL = user.photoURL
      // email = user.email
    } else {
        // No user is signed in.
      }
    return {
      // items: [{ header: '所属チーム' }]
      items: [],
      finishedTournaments: [],
      colorfilter: 'colorfilter-purple'
    };
  },
  created: function created() {
    var _this = this;

    // select teams
    //   var list = this.items
    var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
    var query = db.collection('tournaments').where('endTime', '>', new Date()).orderBy('endTime');

    query.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var obj = doc.data();
        obj.to = '/tournament/' + doc.id;
        _this.items.push(obj);
      });
    });
    // old
    var query2 = db.collection('tournaments').where('endTime', '<', new Date()).orderBy('endTime', 'desc');

    query2.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var obj = doc.data();
        obj.to = '/tournament/' + doc.id;
        _this.finishedTournaments.push(obj);
      });
    });
  },

  methods: {
    update: function update() {
      //
      // email = null
    }
  }
});

/***/ }),

/***/ "LqzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a2896b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("p4Lf");
function injectStyle (ssrContext) {
  __webpack_require__("B7i1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a2896b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MQaZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
  },
  data: function data() {
    return {
      customurl: ''
    };
  },
  mounted: function mounted() {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth?' + _this.$route.params.id;
      } else {
        // サインイン済み
      }
    });
  },

  methods: {
    create: function create() {
      console.log('create');
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      var user = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;

      var obj = {};
      obj.role = 'MEMBRE';
      obj.team = this.$route.params.id;
      obj.user = user.uid;
      obj.status = 'PENDING';

      console.log(obj);
      db.collection('m2m_teams_users').add(obj).then(function () {
        console.log('Document successfully written!');
      }).catch(function (error) {
        console.log('Error add document:', error);
      });
    }
  }
});

/***/ }),

/***/ "MwR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LineIt__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LineIt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LineIt__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a,
    LineIt: __WEBPACK_IMPORTED_MODULE_1_LineIt___default.a
  },
  data: function data() {
    return {
      customurl: ''
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_LineIt___default.a.loadButton();
  },
  created: function created() {
    this.makeurl();
  },

  methods: {
    makeurl: function makeurl() {
      this.customurl = 'https://' + location.hostname + '/#/team/join?t=' + this.$route.params.id;
    },
    sendmail: function sendmail() {
      var user = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;
      var subject = 'バスケットボールチームへの招待';
      var body = user.displayName + 'さんからバスケットボールチームへのご招待です。%0d%0aURLをクリックしてJOINしてください。%0d%0a%0d%0a';
      var bodyurl = this.customurl;

      // ドメイン
      // mailto:?subject=チームへの招待&body=ご感想を%0D%0Aお願いします。
      document.location = 'mailto:' + '?subject=' + subject + '&body=' + body + bodyurl;
    }
  },
  computed: {
    //    LineIt.loadButton()
  }
});

/***/ }),

/***/ "Mzd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("プライバシーポリシー")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('p',[_vm._v("\n当社は、個人情報の重要性を認識し、個人情報保護法に則った運営を行っており、以下の取り組みを実施いたしております。\n")]),_vm._v(" "),_c('p',[_vm._v("\n１. 当社は、お客様個人に関する情報（以下「個人情報」といいます。）の取扱いについて管理責任者を置き、その管理責任者に適切な管理を行わせております。"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n    個人情報管理責任者"),_c('br'),_vm._v("\n    Active Force 代表 高橋 旭"),_c('br'),_vm._v("\n    E-mail：info@ac4th.com\n")]),_vm._v(" "),_c('p',[_vm._v("\n２. お客様から、お客様の個人情報を取得させていただく場合は、その利用の目的を出来る限り特定するとともに、お客様に対する当社の窓口等をあらかじめ明示したうえで、必要な範囲の個人情報を取得させていただきます。\n")]),_vm._v(" "),_c('p',[_vm._v("\n３. 当社は、お客様より取得させていただいた個人情報を適切に管理し、お客様の事前承認なくお客様の同意を得た会社以外の第三者に提供、開示等一切いたしません。ただし、次の場合はこの限りではありません。"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n１) 法令に基づく場合"),_c('br'),_vm._v("\n２) 人の生命、身体または財産の保護のために必要がある場合で、お客様本人の同意を得ることが困難であるとき"),_c('br'),_vm._v("\n３) 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合で、お客様本人の同意を得ることが困難であるとき"),_c('br'),_vm._v("\n４) 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合で、お客様本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n４. 当社が、上記 3．におけるお客様の同意に基づき個人情報を提供する会社には、お客様の個人情報についての秘密保持、安全管理等についての契約を締結して、適切な監督を行います。\n")]),_vm._v(" "),_c('p',[_vm._v("\n５. 当社は、お客様に有益と思われる当社のサービス、又は提携先の商品、サービス等の情報を、電子メール、郵便、電話等によりお客様に連絡させ ていただく場合がございます。お客様は、当社が別途定める方法にてお申し出いただくことにより、これらの取扱いを中止させたり、再開させたりすることがで きます。\n")]),_vm._v(" "),_c('p',[_vm._v("\n６. 当サイトからリンクされている第三者企業が、サービスあるいは懸賞や販売促進活動を通じてお客様の情報を収集することがあります。当社は、これらの第三者企業におけるお客様の個人情報の保護について、いかなる義務や責任も負いませんので予めご了承ください。\n")]),_vm._v(" "),_c('p',[_vm._v("\n７. 当ポリシーに重要な変更がある場合には、サイト上で告知します。 その他の変更については、お客様ご自身が変更点に関しての最新の情報を、当サイト上で随時確認されることを推奨します。確認をされていなかったことに起因 するトラブルに関しては、当社は一切責任を負いかねますので予めご了承下さい。\n")]),_vm._v(" "),_c('p',[_vm._v("\n８. お客様からご提供いただいた個人情報に関して、訂正、修正等を要望される場合は、当社各窓口にご請求下さい。個人情報漏洩防止の観点から、 当該ご請求がお客様ご本人によるものであることが確認できた場合に限り、合理的な期間内に、お客様の個人情報を開示、訂正または削除致します。\n")]),_vm._v(" "),_c('p',[_vm._v("\n９. 当社は、当社が保有する個人情報に関して適用される法令、規範を遵守するとともに、上記各項における取り組みを適宜見直し、改善していきます。\n")]),_vm._v(" "),_c('p',[_vm._v("\n１０. 当プライバシーポリシーに関するお問い合わせは、下記担当までお願い致します。\n")]),_vm._v(" "),_c('p',[_vm._v("\n〒161-0022 "),_c('br'),_vm._v("\n東京都豊島区南池袋2-8-17"),_c('br'),_vm._v("\n第一豊南ビル6階"),_c('br'),_vm._v("\nActive Force　プライバシー管理担当 "),_c('br'),_vm._v("\nE-mail：info@ac4th.com"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n・Cookie（クッキー）について\n")]),_vm._v(" "),_c('p',[_vm._v("\n当サイトは、クッキーを使用することがあります。当社は、主として下記の目的でクッキーを利用します。\n")]),_vm._v(" "),_c('p',[_vm._v("\n・お客様の利用状況調査のため"),_c('br'),_vm._v("\n・お客様が会員制サービスを利用される際、毎回パスワードを入力しなくてもすむようにするため"),_c('br'),_vm._v("\n・お客様がより満足いただけるようサイトを改良したり、個々のお客様に合わせてカスタマイズしたりするため"),_c('br'),_vm._v("\n・お客様の関心事に合わせて有益なサービスや広告を提供するため"),_c('br'),_vm._v("\n・統計分析を行うため"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\nお客様は、ブラウザの設定により、クッキーの受け取りを拒否したり、クッキーを受け取ったとき警告を表示させたりできます。但し、当サイトのサービスに は、クッキーなしではサービス内容に制限が発生することや、利用できない場合もありますので、あらかじめご了承ください。\n")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_firestore__ = __webpack_require__("wmKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_title__ = __webpack_require__("kIpS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_firebaseConfig__ = __webpack_require__("nbjv");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vuex from 'vuex'




// import firebase from 'firebase'










__WEBPACK_IMPORTED_MODULE_8__helpers_firebaseConfig__["a" /* FBApp */].auth().onAuthStateChanged(function (user) {
  return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_USER', user);
});
__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_FB_APP', __WEBPACK_IMPORTED_MODULE_8__helpers_firebaseConfig__["a" /* FBApp */]);
__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_FB_UI_APP', __WEBPACK_IMPORTED_MODULE_8__helpers_firebaseConfig__["b" /* FBUIApp */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_7__helpers_title__["a" /* default */]);

// firestore
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_firestore___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-112643607-1',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
});

var _firestore = __WEBPACK_IMPORTED_MODULE_8__helpers_firebaseConfig__["a" /* FBApp */].firestore();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  firestore: function firestore() {
    return {
      teams: _firestore.collection('teams')
    };
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('dateformat', function (value) {
  if (!value) return '';

  var hour = value.getHours();
  var minute = value.getMinutes();
  var dayOfWeek = value.getDay();
  var dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek];

  value = value.getFullYear() + '年' + (value.getMonth() + 1) + '月' + value.getDate() + '日（' + dayOfWeekStr + '）' + hour + ':' + ('0' + minute).slice(-2);
  return value;
});

/***/ }),

/***/ "NTGm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Poo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
  },
  data: function data() {
    return {
      payMethod: 'ON-SITE',
      item: { location: null },
      items: [],
      to: null,
      team: null,
      entrySize: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth?mode=select&signInSuccessUrl=/tournamentconfirm/' + _this.$route.params.id;
      } else {
        // サインイン済み
      }
    });

    // select tournament
    var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
    var docRef = db.collection('tournaments').doc(this.$route.params.id);

    // Read the document.
    docRef.get().then(function (doc) {
      if (doc.exists) {
        // Document read successfully.
        _this.item = doc.data();
        _this.to = '/tournamentconfirm/' + _this.$route.params.id;
        _this.init();
      } else {
        console.log('No such document!');
      }
    }).catch(function (error) {
      console.log('Error getting document:', error);
    });
  },

  methods: {
    init: function init() {
      var _this2 = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      var query = db.collection('m2m_teams_users').where('user', '==', __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid) // TODO
      .where('role', '==', 'ADMIN');
      query.get().then(function (querySnapshot) {
        // this.entrySize = querySnapshot.size
        querySnapshot.forEach(function (documentSnapshot) {
          var obj = documentSnapshot.data();
          // user
          var docRef = db.collection('teams').doc(obj.team);
          docRef.get().then(function (doc) {
            if (doc.exists) {
              _this2.items.push({ label: doc.data().teamName, value: doc.id });
              _this2.team = { label: doc.data().teamName, value: doc.id
                // this.team.value = doc.id
              };
            } else {
              console.log('No such document!');
            }
          }).catch(function (error) {
            console.log('Error getting document:', error);
          });
        });
      });
    },
    entry: function entry() {
      var _this3 = this;

      // if (!this.items.size) {
      //   this.$router.push('/user/profile?u=/tournamentconfirm/' + this.$route.params.id)
      //   return
      // }
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      var id = this.$route.params.id + this.team.value; // TODO

      var document = db.collection('entries').doc(id); // + this.$route.params.id)
      document.set({
        team: this.team.value,
        tournament: this.$route.params.id,
        payMethod: this.payMethod,
        time: new Date().getTime()
      }).then(function () {
        // Document created successfully.

        // update tournament
        // let remainings = this.item.capacity - this.entrySize
        var docRef = db.collection('tournaments').doc(_this3.$route.params.id);
        // let updremaining = docRef.data().remaining - 1
        // console.log('remaining->', updremaining)
        docRef.get().then(function (doc) {
          docRef.update({ remaining: doc.data().remaining - 1 });
        }).catch(function (error) {
          console.log('Error getting document:', error);
        });

        //        docRef.update({remaining: docRef.data().remaining - 1})
        _this3.$router.push('/tournamententered/' + id);
      });
    }
  }
});

/***/ }),

/***/ "Q4/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("よくある質問")])]),_vm._v(" "),_vm._l((_vm.faqs),function(item){return [_c('p',[_vm._v(" Q. "+_vm._s(item[0]))]),_vm._v(" "),_c('p',[_vm._v(" A. "+_vm._s(item[1]))]),_vm._v(" "),_c('v-divider')]})],2),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"line-it-button",staticStyle:{"display":"none"},attrs:{"id":"sendline-btn","data-lang":"ja","data-type":"share-a","data-url":_vm.customurl}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qptw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Managementgroup_vue__ = __webpack_require__("1Tl+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cbe6062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Managementgroup_vue__ = __webpack_require__("Bf80");
function injectStyle (ssrContext) {
  __webpack_require__("sbCM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Managementgroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cbe6062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Managementgroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RGt2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rp40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__("LqzL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d405e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__("EfMD");
function injectStyle (ssrContext) {
  __webpack_require__("TYZT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d405e62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SszN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TYZT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WTWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[(_vm.isEntry)?_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',{staticClass:"teal--text "},[_vm._v("エントリー済みです")])]):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"black--text display-2s"},[_c('v-card-title',{staticClass:"ah-tournament-lead",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.title)}})]),_vm._v(" "),(_vm.item.endTime <  new Date())?_c('div',{staticClass:"red--text"},[_vm._v("受付終了")]):_vm._e(),_vm._v(" "),(_vm.item.endTime >  new Date())?_c('div',{staticClass:"red--text"},[_vm._v("あと残り"+_vm._s(_vm.item.remaining)+"チーム")]):_vm._e()])],1),_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("event")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("dateformat")(_vm.item.startTime))+" ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(_vm.item.location)+"\n              ")]),_vm._v(" "),_c('v-list-tile-title',[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.item.address))])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("payment")])],1),_vm._v(" "),_c('v-list-tile-content',[(_vm.item.entryFee)?_c('v-list-tile-title',[_vm._v("参加費：¥ "+_vm._s(_vm.item.entryFee.toLocaleString()))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("group")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.capacity)+"チーム募集\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('h5',{staticClass:"mt-3 mb-0"},[_vm._v("詳細")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.item.subTitle)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.item.info)}}),_vm._v(" "),_c('div',{staticClass:"ggmap"},[(_vm.item.location == '南長崎スポーツセンター')?_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12956.232516014641!2d139.6832012!3d35.7247889!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8a27deea799a5cd7!2z5Y2X6ZW35bSO44K544Od44O844OE44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1517322640291","width":"600","height":"550","frameborder":"0","allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.item.location == '品川区総合体育館')?_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.143854391381!2d139.72607431548823!3d35.6241799802077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188af769b23af9%3A0x5eceea4ed39b40f7!2z5ZOB5bed5Yy657eP5ZCI5L2T6IKy6aSo!5e0!3m2!1sja!2sjp!4v1522681830305","width":"600","height":"550","frameborder":"0","allowfullscreen":""}}):_vm._e()]),_vm._v(" "),(false)?_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.teams),function(item){return [(item.header)?_c('v-subheader',{domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":"","to":item.to}},[_c('v-list-tile-avatar',[(item.avatar)?_c('img',{attrs:{"src":item.avatar}}):_c('img',{attrs:{"src":_vm.defaultTeamAvatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.teamName)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2):_vm._e(),_vm._v(" "),(_vm.item.endTime >  new Date())?_c('div',[(!_vm.isEntry && _vm.item.remaining > 0)?_c('v-btn',{attrs:{"block":"","secondary":"","green":"","to":this.to}},[_vm._v("エントリーに進む")]):(_vm.isEntry)?_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',{staticClass:"teal--text "},[_vm._v("エントリー済みです")])]):_vm._e(),_vm._v(" "),(_vm.item.remaining == 0)?_c('div',{staticClass:"red--text"},[_vm._v("満員です")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.item.endTime <  new Date())?_c('div',[(!_vm.isEntry && _vm.item.remaining > 0)?_c('v-btn',{attrs:{"block":"","secondary":"","green":"","to":this.to,"disabled":""}},[_vm._v("受付終了")]):_vm._e()],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WVnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rule_vue__ = __webpack_require__("/0NQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15993d1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rule_vue__ = __webpack_require__("pP2Z");
function injectStyle (ssrContext) {
  __webpack_require__("wfH6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15993d1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xgpe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YEqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("チームへの招待状")]),_vm._v(" "),_c('p',[_vm._v("チームに加わって、一緒にバスケットボールをしましょう。")])])]),_vm._v(" "),_c('v-btn',{attrs:{"block":""},on:{"click":_vm.create}},[_vm._v("チームに入る")]),_vm._v(" "),_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('div',{staticClass:"fb-send",attrs:{"data-href":"https://www.your-domain.com/your-page.html","data-layout":"button_count"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_Auth__ = __webpack_require__("0PBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_UserProfile__ = __webpack_require__("ajUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_team_TeamProfile__ = __webpack_require__("aug8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_team_Members__ = __webpack_require__("gPw+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_team_Invite__ = __webpack_require__("dFAc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_team_Join__ = __webpack_require__("LBmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tournament_TournamentDetail__ = __webpack_require__("Bfkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tournament_entered__ = __webpack_require__("mIs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tournament_TournamentConfirm__ = __webpack_require__("kB5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tournament_TournamentCancel__ = __webpack_require__("6EEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_tournament_TournamentSearch__ = __webpack_require__("kjW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_schedule_Index__ = __webpack_require__("Z1Wv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Faq__ = __webpack_require__("EMFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Rule__ = __webpack_require__("WVnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PrivacyPolicy__ = __webpack_require__("ZWRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Terms__ = __webpack_require__("Rp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Managementgroup__ = __webpack_require__("Qptw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Sendgrid__ = __webpack_require__("1IaW");























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Home__["default"]
  }, {
    path: '/sendgrid',
    name: 'Sendgrid',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Sendgrid__["a" /* default */]
  }, {
    path: '/rule',
    name: 'Rule',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Rule__["a" /* default */]
  }, {
    path: '/managementgroup',
    name: 'Managementgroup',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Managementgroup__["a" /* default */]
  }, {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: __WEBPACK_IMPORTED_MODULE_17__components_PrivacyPolicy__["a" /* default */]
  }, {
    path: '/terms',
    name: 'Terms',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Terms__["a" /* default */]
  }, {
    path: '/faq',
    name: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Faq__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/auth',
    name: 'Auth',
    component: __WEBPACK_IMPORTED_MODULE_3__components_user_Auth__["a" /* default */]
  }, {
    path: '/schedule',
    name: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_14__components_schedule_Index__["a" /* default */]
  }, {
    path: '/user/profile',
    name: 'UserProfile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_user_UserProfile__["a" /* default */]
  },
  // {
  //   path: '/team/profile',
  //   name: 'TeamProfile',
  //   component: TeamProfile
  // },
  {
    path: '/teams/:id',
    name: 'TeamProfile',
    component: __WEBPACK_IMPORTED_MODULE_5__components_team_TeamProfile__["a" /* default */]
  }, {
    path: '/team/:id/members',
    name: 'TeamMembers',
    component: __WEBPACK_IMPORTED_MODULE_6__components_team_Members__["a" /* default */]
  }, {
    path: '/team/:id/invite',
    name: 'TeamInvite',
    component: __WEBPACK_IMPORTED_MODULE_7__components_team_Invite__["a" /* default */]
  }, {
    path: '/team/join/:id',
    name: 'TeamJoin',
    component: __WEBPACK_IMPORTED_MODULE_8__components_team_Join__["a" /* default */]
  }, {
    path: '/tournament/:id',
    name: 'Tounament',
    component: __WEBPACK_IMPORTED_MODULE_9__components_tournament_TournamentDetail__["a" /* default */]
  }, {
    path: '/tournamententered/:id',
    name: 'TournamentEntered',
    component: __WEBPACK_IMPORTED_MODULE_10__components_tournament_entered__["a" /* default */]
  }, {
    path: '/tournament',
    name: 'TournamentSearch',
    component: __WEBPACK_IMPORTED_MODULE_13__components_tournament_TournamentSearch__["a" /* default */]
  }, {
    path: '/tournamentconfirm/:id',
    name: 'TounamentConfirm',
    component: __WEBPACK_IMPORTED_MODULE_11__components_tournament_TournamentConfirm__["a" /* default */]
  }, {
    path: '/tournament/:id/cancel',
    name: 'TounamentCancel',
    component: __WEBPACK_IMPORTED_MODULE_12__components_tournament_TournamentCancel__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ "Z1Wv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("s/hm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d6af58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("9dS2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d6af58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZRtU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-parallax',{attrs:{"src":"/static/DSC02731.jpg","height":"400"}},[_c('v-layout',{attrs:{"column":"","justify-center":""}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h3',{staticClass:"white--text"},[_vm._v("バスケが大好きな人達へ")]),_vm._v(" "),_c('p',[_vm._v("ACTIVE HOOPはアマチュア向けバスケットボール大会を開催します")]),_vm._v(" "),_c('v-btn',{staticClass:"body2 mt-3 mb-5",staticStyle:{"width":"150px"},attrs:{"large":"","dark":"","color":"cyan","to":"/tournament"}},[_vm._v("大会をさがす")])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-container',{staticStyle:{"background-color":"#f1f1f1"}},[_c('h5',{staticStyle:{"font-weight":"600","text-align":"center"}},[_vm._v("ACTIVE HOOPはバスケが大好きな人の味方です！")]),_vm._v(" "),_c('p',[_vm._v("\n        いつものチームの気心知れた仲間と、普段は敵同士のアイツやあの子と新しいチームで、エンジョイバスケ！\n        "),_c('br'),_c('br'),_vm._v("\n        一般大会以外にも、同窓会、OB会、会社対抗など色々な企画にチャレンジ！！\n        こんなバスケがやってみたい！というものはお気軽にお声掛け下さい。\n        "),_c('br'),_c('br'),_vm._v("\n        その他、大会に出たことがないチームへのコーチ派遣や各種スクールも計画中！\n      ")])]),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"video"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/myxj79sX4l8?showinfo=0&rel=0","frameborder":"0","allowfullscreen":""}})])]),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","text-xs-center":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',[_c('v-card-text',{staticClass:"px-0"},[_c('v-btn',{staticClass:"blue--text",attrs:{"icon":"","to":"/rule"}},[_c('div',{staticStyle:{"display":"block"}},[_c('v-icon',{attrs:{"icon":""}},[_vm._v("info")]),_c('div',[_vm._v("ルール")])],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',[_c('v-card-text',{staticClass:"px-0"},[_c('v-btn',{staticClass:"blue--text",attrs:{"icon":"","to":"/faq"}},[_c('div',{staticStyle:{"display":"block"}},[_c('v-icon',{attrs:{"icon":""}},[_vm._v("question_answer")]),_vm._v(" "),_c('div',[_vm._v("よくある質問")])],1)])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',[_c('v-card-text',{staticClass:"px-0"},[_c('v-btn',{staticClass:"blue--text",attrs:{"icon":"","href":"https://goo.gl/forms/Zav06EtY3Wu6PEl12","target":"_blank"}},[_c('div',{staticStyle:{"display":"block"}},[_c('v-icon',{attrs:{"icon":""}},[_vm._v("email")]),_vm._v(" "),_c('div',[_vm._v("お問い合わせ")])],1)])],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('v-divider',{staticClass:"mt-4 mb-2"}),_vm._v(" "),_c('h4',{staticClass:"mt-2 mb-2",staticStyle:{"font-weight":"500","text-align":"center"}},[_vm._v("SNS")]),_vm._v(" "),_c('ul',{staticClass:"table-ul"},[_c('li',{},[_c('div',[_c('a',{attrs:{"href":"https://www.facebook.com/Active4th/","target":"_blank"}},[_c('span',{},[_c('img',{attrs:{"src":"/static/social/facebook.svg","alt":"","width":"35","height":"35"}})])])])]),_vm._v(" "),_c('li',{},[_c('div',[_c('a',{attrs:{"href":"https://twitter.com/Active4th","target":"_blank"}},[_c('span',{},[_c('img',{attrs:{"src":"/static/social/twitter.svg","alt":"","width":"35","height":"35"}})])])])]),_vm._v(" "),_c('li',{},[_c('div',[_c('a',{staticClass:"socialIcon",attrs:{"href":"https://www.instagram.com/activehoop/","target":"_blank"}},[_c('span',{},[_c('img',{attrs:{"src":"/static/social/instagram.svg","alt":"","width":"35","height":"35"}})])])])]),_vm._v(" "),_c('li',{},[_c('div',[_c('a',{staticClass:"socialIcon",attrs:{"href":"https://www.youtube.com/channel/UCHGgW59TuBuoGxxalYuaSYw","target":"_blank"}},[_c('span',{},[_c('img',{attrs:{"src":"/static/social/youtube.svg","alt":"","width":"35","height":"35"}})])])])])])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"mt-2":"","mb-5":"","grid-list-md":"","text-xs-center":""}},[_c('h4',{staticClass:"mt-2 mb-4",staticStyle:{"font-weight":"500"}},[_vm._v("SPONSOR")]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"http://www.molten.co.jp/sports/jp/basketball/index.html","target":"_blank"}},[_c('img',{attrs:{"src":"/static/sponsor/molten.png","alt":"molten","width":"300"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('a',{attrs:{"href":"https://tokyo-excellence.jp/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/sponsor/excellence.jpg","alt":"東京エクセレンス","width":"300"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('a',{attrs:{"href":"https://b-five.jp","target":"_blank"}},[_c('img',{attrs:{"src":"/static/sponsor/b-five.jpg","alt":"B-Five","width":"300"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('a',{attrs:{"href":"https://breakal.com","target":"_blank"}},[_c('img',{attrs:{"src":"/static/sponsor/breakal.jpg","alt":"BREAKAL","width":"300"}})])]),_vm._v(" "),_c('v-btn',{staticClass:"body2 mt-5 mb-2",attrs:{"block":"","large":"","dark":"","color":"cyan","to":"/tournament"}},[_vm._v("大会をさがす")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZWRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__("hXTq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267bb548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__("Mzd1");
function injectStyle (ssrContext) {
  __webpack_require__("RGt2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267bb548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZoUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-avatar',{attrs:{"size":"40px"}},[(_vm.photoURL)?_c('img',{attrs:{"src":_vm.item.avatar}}):_c('img',{attrs:{"src":_vm.defaultTeamAvatar}})]),_vm._v(" "),(_vm.teamObj.teamName)?_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.teamObj.teamName))])]):_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("新しいチームの誕生")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("\n              あなたのチームを登録しましょう\n            ")])])],1)]),_vm._v(" "),_c('form',[_c('v-text-field',{attrs:{"label":"チームネーム","required":""},model:{value:(_vm.teamObj.teamName),callback:function ($$v) {_vm.$set(_vm.teamObj, "teamName", $$v)},expression:"teamObj.teamName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"チーム紹介","required":""},model:{value:(_vm.teamObj.teamInfo),callback:function ($$v) {_vm.$set(_vm.teamObj, "teamInfo", $$v)},expression:"teamObj.teamInfo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"地域","items":_vm.items},model:{value:(_vm.teamObj.select),callback:function ($$v) {_vm.$set(_vm.teamObj, "select", $$v)},expression:"teamObj.select"}})],1),_vm._v(" "),_c('div',{staticClass:"orange--text"},[_vm._v("メンバー管理機能を準備中")]),_vm._v(" "),(!this.isRegist)?_c('v-btn',{attrs:{"disabled":!(_vm.teamObj.teamName && _vm.teamObj.teamInfo && _vm.teamObj.select),"block":"","secondary":"","green":""},on:{"click":_vm.create}},[_vm._v("登録")]):_vm._e(),_vm._v(" "),(this.isRegist)?_c('v-btn',{attrs:{"disabled":!(_vm.teamObj.teamName && _vm.teamObj.teamInfo && _vm.teamObj.select),"block":"","secondary":"","green":""},on:{"click":_vm.update}},[_vm._v("更新する")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ajUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("qAS9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10993b06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("hDqN");
function injectStyle (ssrContext) {
  __webpack_require__("Xgpe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10993b06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aug8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamProfile_vue__ = __webpack_require__("2HMi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14390745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamProfile_vue__ = __webpack_require__("ZoUw");
function injectStyle (ssrContext) {
  __webpack_require__("7vb3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14390745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ayse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('img',{staticStyle:{"margin-top":"40px"},attrs:{"src":"https://sendgrid.kke.co.jp/images/common/logo.svg"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"30px","font-size":"16px"}},[_vm._v("\n        審査のほど、よろしくお願いいたします。\n        ")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cAxy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dFAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__ = __webpack_require__("MwR+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5b5a36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__ = __webpack_require__("25wk");
function injectStyle (ssrContext) {
  __webpack_require__("6iaR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5b5a36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gPw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__ = __webpack_require__("D9pK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa43944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__ = __webpack_require__("6bqw");
function injectStyle (ssrContext) {
  __webpack_require__("9nvG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa43944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      faqs: [['チーム統一のユニフォームが無いのですが、参加できますか？', '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'], ['大会の予約はいつからできますか？', '大会によって異なるのですが、概ね3か月前から大会当日までとなります。参加チーム枠もありますので、ご連絡ください。'], ['チーム統一のユニフォームが無いのですが、参加できますか？', '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'], ['当日の持ち物をお教えください。', '大会当日は運動できる服装と内履きをご持参ください。当大会ではビブの貸出、ボールの貸出を行っております。ご気軽にご参加ください。'], ['1チーム何名まで参加できますか？', '何名でも可能です。過去に最大で20名で参加されたチームがありました。'], ['5人以下で参加できますか？', 'チームにて参加をいただいているのでご遠慮お願いします。ただし、個人参加大会も行っているので、そちらをご検討ください。'], ['当日、人数が揃わない場合、棄権になってしまいますか？', '1名2名の欠員であれば当運営メンバーが代行します。また、大会責任者へご相談いただければ、他チームからの助っ人を募集いたします。'], ['審判やオフィシャルが出来ないのですが、参加してもいいですか？', '審判、オフィシャルは当大会運営部で行います。ご気軽にご参加ください。'], ['ケガをした時の対応について教えてください。', '基本的に怪我は自己責任となります。怪我の責任は一切負いかねます。各自、スポーツ保険に加入されることをお勧めします。'], ['領収書の発行をお願いできますか？', '可能です。当日、お申し出ください。'], ['同一大会に2チームエントリーしたいのですが、可能でしょうか？', '可能です。ただし、皆さんに楽しんでもらうために4チームに同時エントリーはご遠慮いただいております。'], ['ハーフではなくクオーターで試合はできませんか？', '当大会は、多くのチームと試合を行う事で、すべてのチームがエンジョイできる大会を目指しています。クオーター大会も行っていますが、基本はハーフとなります。'], ['大会の中止はありますか？', '当運営部の要因で中止した事はありませんが、交通事情にて予定参加チームが欠席したケースはございます。その場合、予定チーム数の半分以上が欠席の場合、予定とは異なった大会を行わせていただきます。'], ['学生（20歳以下）が参加できる大会はありますか？', '保護者の許可があれば参加可能ですが、代表者様もしくは引率の方は20歳以上とさせてください。'], ['練習試合を企画しているのですが、協力いただくことは可能でしょうか？', 'もちろんできる限り協力させていただきますが、ご希望にそぐわない場合もございますので、概要と当大会運営部が行う事をメールにてご連絡ください。']]
    };
  }
});

/***/ }),

/***/ "hDqN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[(_vm.isUnregistTeam)?_c('v-alert',{attrs:{"color":"cyan","icon":"info","value":"true"}},[_vm._v("\n        「チームを作る」からチームを登録して、大会にエントリーしましょう。\n      ")]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-avatar',{attrs:{"size":"60px"}},[(_vm.user)?_c('img',{attrs:{"src":_vm.user.photoURL,"alt":"avatar"}}):_vm._e()]),_vm._v(" "),(_vm.user)?_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.user.displayName))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"subheading"})],1)]),_vm._v(" "),_c('form',[(_vm.user)?_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}):_vm._e()],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [(item.header)?_c('v-subheader',{key:item.header,domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":"","to":item.to}},[_c('v-list-tile-avatar',[(item.avatar)?_c('img',{attrs:{"src":item.avatar}}):_c('img',{attrs:{"src":_vm.defaultTeamAvatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2),_vm._v(" "),(_vm.isUnregistTeam)?_c('v-btn',{staticClass:"white--text",attrs:{"color":"cyan","to":"/teams/regist"}},[_vm._v("チーム\bを作る")]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"divider my-5"}),_vm._v(" "),_c('a',{on:{"click":_vm.logout}},[_vm._v("ログアウトする")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hXTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "hrrE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kB5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentConfirm_vue__ = __webpack_require__("Poo2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d050b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentConfirm_vue__ = __webpack_require__("8c0z");
function injectStyle (ssrContext) {
  __webpack_require__("Ar7I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d050b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kIpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var title = this.$options.title;

    if (title) {
      title = typeof title === 'function' ? title.call(this) : title;
      document.title = title + ' - ACTIVE HOOP';
    }
  }
});

/***/ }),

/***/ "kjW8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentSearch_vue__ = __webpack_require__("LFbd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5927bd41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentSearch_vue__ = __webpack_require__("s86j");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TournamentSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5927bd41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TournamentSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2248b4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("ZRtU");
function injectStyle (ssrContext) {
  __webpack_require__("5A05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2248b4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lT2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mIs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entered_vue__ = __webpack_require__("5CMu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c464478_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entered_vue__ = __webpack_require__("1TMP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entered_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c464478_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entered_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mrXD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__("2ahc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebaseui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a,
    firebaseui: __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a
  },
  data: function data() {
    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.

      } else {
          // No user is signed in.

        }
    });
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  mounted: function mounted() {
    // Initialize Cloud Firestore through Firebase
    var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

    // FirebaseUI config.
    var uiConfig = {
      callbacks: {
        signInSuccess: function signInSuccess(currentUser, credential, redirectUrl) {
          console.log(currentUser);
          console.log(credential);
          console.log(redirectUrl);
          alert(currentUser.displayName);
          alert(currentUser.email);
          // Do something.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.

          // firestore
          db.collection('users').add({
            uid: currentUser.uid,
            name: currentUser.displayName,
            email: currentUser.email,
            photoURL: currentUser.photoURL

          }).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id);
          }).catch(function (error) {
            console.error('Error adding document: ', error);
          });

          return true;
        },
        uiShown: function uiShown() {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById('loader').style.display = 'none';
        }
      },
      //    signInSuccessUrl: '<url-to-redirect-to-on-success>',
      signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      //        Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.FacebookAuthProvider.PROVIDER_ID
      //        Firebase.auth.GithubAuthProvider.PROVIDER_ID
      ],
      // Terms of service url.
      tosUrl: '<your-tos-url>'

      // Initialize the FirebaseUI Widget using Firebase.
    };var ui = new __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth());
    // The start method will wait until the DOM is loaded.
    ui.start('#firebaseui-auth-container', uiConfig);
  }
});

/***/ }),

/***/ "nbjv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FBApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FBUIApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__("2ahc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebaseui__);



var config = {
  /*
    apiKey: process.env.FB_API_KEY,
    authDomain: process.env.FB_AUTH_DOMAIN,
    databaseURL: process.env.FB_DATABASE_URL,
    storageBucket: process.env.FB_STORAGE_BUCKET,
    messagingSenderId: process.env.FB_MESSAGING_SENDER_ID,
  */

  apiKey: 'AIzaSyD0vXlxrpGU0gSW9iSfxPxa3-F_ViW3LNk',
  authDomain: 'activehoop.firebaseapp.com',
  databaseURL: 'https://activehoop.firebaseio.com',
  projectId: 'activehoop',
  storageBucket: 'activehoop.appspot.com',
  messagingSenderId: '883937132402'

  // stg

  // apiKey: 'AIzaSyDSNl0WYEiB08f3DMFD_fllKKP6CnmmpgI',
  // authDomain: 'stg-activehoop.firebaseapp.com',
  // databaseURL: 'https://stg-activehoop.firebaseio.com',
  // projectId: 'stg-activehoop',
  // storageBucket: 'stg-activehoop.appspot.com',
  // messagingSenderId: '697859449072'

};

var FBApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
var FBUIApp = new __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth(FBApp));

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var getters = {
  user: function user(state) {
    return state.user;
  },
  fbApp: function fbApp(state) {
    return state.fbApp;
  },
  fbUiApp: function fbUiApp(state) {
    return state.fbUiApp;
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    user: null,
    fbApp: null,
    fbUiApp: null
  },
  getters: getters,
  mutations: {
    /* eslint-disable no-param-reassign */
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_FB_APP: function SET_FB_APP(state, fbApp) {
      state.fbApp = fbApp;
    },
    SET_FB_UI_APP: function SET_FB_UI_APP(state, fbUiApp) {
      state.fbUiApp = fbUiApp;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "p32l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "p4Lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-toolbar',{attrs:{"fixed":"","app":""}},[_c('v-btn',{staticClass:"toolbar__title",attrs:{"id":"logo","flat":"","to":"/"}},[_vm._v("ACTIVE HOOP")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","to":"/schedule"}},[_c('v-icon',{attrs:{"icon":""}},[_vm._v("date_range")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","to":"/tournament"}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),(_vm.user)?_c('v-btn',{attrs:{"dark":"","icon":"","to":"/user/profile"}},[_c('v-icon',[_vm._v("person")])],1):_vm._e(),_vm._v(" "),(_vm.user==null)?_c('v-btn',{attrs:{"dark":"","icon":"","to":"/auth"}},[_vm._v("\n    ログイン\n  ")]):_vm._e()],1),_vm._v(" "),_c('main',[_c('v-content',[_c('v-container',{staticClass:"ah-container",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3",staticStyle:{"font-size":"12px"}},[_c('div',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" ACTIVE HOOP All rights reserved.")])]),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 mt-0"},[_c('router-link',{staticClass:"ah-footer-legal-link",attrs:{"to":"/privacypolicy"}},[_vm._v("プライバシーポリシー")]),_vm._v(" "),_c('router-link',{staticClass:"ah-footer-legal-link",attrs:{"to":"/terms"}},[_vm._v("利用規約")]),_vm._v(" "),_c('router-link',{staticClass:"ah-footer-legal-link",attrs:{"to":"/managementgroup"}},[_vm._v("運営団体")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pP2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","md44":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("大会ルール")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('p',[_vm._v("\n◆試合時間について"),_c('br'),_vm._v("\n・各試合時間は7分ハーフで時間流し。"),_c('br'),_vm._v("\n・前後半の各残り30秒からゲームが止まる全てのシチュエーションで時間を止める。"),_c('br'),_vm._v("\n・3秒、5秒、8秒、24秒はレフリーに一任する。"),_c('br'),_vm._v("\n・タイムアウト（以下、T.０と称す）は各1チーム前後半で各1回ずつ、30秒を与える。"),_c('br'),_vm._v("\n・T.Oの申請は出場選手は審判へ、ベンチはオフィシャルへ申請する。申請後、ゲームが止まる全てのシチュエーションで施行されます。"),_c('br'),_vm._v("\n・ケガ等の場合レフリーは自らの判断で時間を止める事が出来る。\n")]),_vm._v(" "),_c('p',[_vm._v("\n◆ルールについて"),_c('br'),_vm._v("\n・レフリー、オフィシャル、ゲームマスター（運営部）は自らの判断にて判定する事が出来る。"),_c('br'),_vm._v("\n・パーソナルファウルのカウントはしないが、テクニカルファウルはカウントする。テクニカルファウル2回で退場とする。"),_c('br'),_vm._v("\n・チームファウルはカウントし、前後半でクリアする。各５回目以降にファウルを行うと、シュート動作中のファウルでなくても、1点加点後、相手ボールとなる。"),_c('br'),_vm._v("\n・レフリーへの過度な主張、暴言はテクニカルファウルの対象となる。"),_c('br'),_vm._v("\n・コートの中はもちろん、コート外での過度な主張、"),_c('br'),_vm._v("\n 暴言はテクニカルファウルの対象とし、次回の試合にファウルコールを行う。"),_c('br'),_vm._v("\n・チーム代表者のみが、運営部に主張、申し立てを行う事が出来る。"),_c('br'),_vm._v("\n・ノーチャージエリアの適用はしない。\n")]),_vm._v(" "),_c('p',[_vm._v("\n◆得点、大会別ルール"),_c('br'),_vm._v("\n・フリースローが無い大会の場合、フリースローシュチエーション時には、 2スロー以上の場合、１点を加点し、その後、オフェンスボールとなる。１スローの場合は1点を加点後、ディフェンスボールとなる。"),_c('br'),_vm._v("\n・大会により女性プレイヤーへ通常ポイントに加点を行う事がある。"),_c('br'),_vm._v("\n加点内容は事前に大会毎に決定する。（大会加算）"),_c('br'),_vm._v("\n・大会により年齢別にて加点減点を個人または、チームに対し行う事がある。その際、女性の得点は大会加算後に行う。\n")]),_vm._v(" "),_c('p',[_vm._v("\n◆大会形式"),_c('br'),_vm._v("\n・総当たりのリーグ戦とする。"),_c('br'),_vm._v("\n   ただし、不参加のチーム等でチーム数に変更がある場合は、上記の事前に告知した内容を変更することがある。"),_c('br'),_vm._v("\n・各試合の勝敗で勝ち数が多いチームの優勝とする。"),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n◆その他のルールに関して"),_c('br'),_vm._v("\n・国際バスケットボール連盟(FIBA)が定めた「Official Basketball Rules 2014」に準拠する。\n")])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"line-it-button",staticStyle:{"display":"none"},attrs:{"id":"sendline-btn","data-lang":"ja","data-type":"share-a","data-url":_vm.customurl}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qAS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    firebase: __WEBPACK_IMPORTED_MODULE_2_firebase___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    user: 'user'
  })),
  data: function data() {
    return {
      defaultTeamAvatar: '/static/defaultteam.png',
      items: [{ header: '所属チーム' }],
      isUnregistTeam: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth';
      } else {
        // サインイン済み

        // select teams
        var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
        var query = db.collection('m2m_teams_users').where('user', '==', user.uid) // TODO
        .where('role', '==', 'ADMIN');
        query.get().then(function (querySnapshot) {
          // this.entrySize = querySnapshot.size
          if (querySnapshot.size === 0) {
            _this.isUnregistTeam = true;
          }
          querySnapshot.forEach(function (documentSnapshot) {
            var obj = documentSnapshot.data();
            // team
            var docRef = db.collection('teams').doc(obj.team);
            docRef.get().then(function (doc) {
              if (doc.exists) {
                _this.items.push({ avatar: doc.avatar, title: doc.data().teamName, subtitle: doc.data().teamInfo, to: '/teams/' + doc.id });
              } else {
                console.log('No such document!');
              }
            }).catch(function (error) {
              console.log('Error getting document:', error);
            });
          });
        });
      }
    });
  },

  methods: {
    update: function update() {
      var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();

      var docRef = db.collection('users').doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid);
      docRef.update(this.teamObj).then(function () {
        console.log('Document successfully updated!');
      }).catch(function (error) {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error);
      });
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut().then(this.onSignOut, this.onError);
      // commit('setUser', null)
    },
    onSignOut: function onSignOut() {
      console.log('onSignOut');
      this.$router.push({ path: '/' });
    },
    onError: function onError() {
      console.error('onError');
    }
  }
});

/***/ }),

/***/ "s/hm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        // location.href = '/#/auth?' + this.$route.params.id
      } else {
        // サインイン済み
        _this.init();
      }
    });
  },

  methods: {
    init: function init() {
      var _this2 = this;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

      var user = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;
      var query = db.collection('m2m_teams_users').where('user', '==', user.uid);
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (documentSnapshot) {
          var obj = documentSnapshot.data();

          db.collection('entries').where('team', '==', obj.team).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              var obj = doc.data();
              var docRef = db.collection('tournaments').doc(obj.tournament);
              // Read the document.
              docRef.get().then(function (doc) {
                if (doc.exists) {
                  var obj = doc.data();
                  if (obj.endTime > new Date()) {
                    obj.to = '/tournament/' + doc.id;
                    _this2.items.push(obj);
                  }
                } else {
                  console.log('No such document!');
                }
              }).catch(function (error) {
                console.log('Error getting document:', error);
              });
            });
          });
        });
      });
    },
    tournaments: function tournaments() {
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
      db.collection('tournaments').get();
    }
  }

});

/***/ }),

/***/ "s86j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('h4',[_vm._v("近日開催イベント")]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[(_vm.items)?_c('p',[_vm._v("現在予定されているイベントはございません。"),_c('br')]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return [_c('v-card',{staticClass:"mb-3",attrs:{"to":item.to}},[_c('v-card-media',{staticClass:"white--text",class:'colorfilter-' + item.category,attrs:{"height":"200px","src":"/static/carousel/1.JPG"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-center":"","flexbox":""}},[_c('div',{staticClass:"ah-tournament-card"},[_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("dateformat")(item.startTime)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_c('div',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(item.subTitle))])]),_vm._v(" "),_c('span',{staticClass:"display-1"})])],1)],1)],1)],1)]})],2),_vm._v(" "),_c('h4',[_vm._v("終了済みイベント")]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.finishedTournaments),function(item){return [_c('v-card',{staticClass:"mb-3",attrs:{"to":item.to}},[_c('v-card-media',{staticClass:"white--text",class:'colorfilter-' + item.category,attrs:{"height":"230px","src":"/static/carousel/1.JPG"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-center":"","flexbox":""}},[_c('div',{staticClass:"ah-tournament-finished-card"},[_c('span',{staticClass:"sub-title",staticStyle:{"background-color":"red","display":"table"}},[_vm._v("受付終了")]),_vm._v(" "),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("dateformat")(item.startTime)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_c('div',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(item.subTitle))])]),_vm._v(" "),_c('span',{staticClass:"display-1"})])],1)],1)],1)],1)]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sbCM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},slot:"activator"},[_vm._v("ログイン")]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","to":"/user/profile"},slot:"activator"},[_vm._v("ログイン済み")]),_vm._v(" "),_c('v-card',{staticClass:"background"},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('h2',{attrs:{"id":"servicetitle"}},[_vm._v("active hoop")]),_vm._v(" "),_c('div',{staticClass:"pt-5",attrs:{"id":"firebaseui-auth-container"}}),_vm._v(" "),_c('div',{attrs:{"id":"loader"}},[_vm._v("Loading...")]),_vm._v(" "),_c('p',{attrs:{"id":"termmessage"}},[_vm._v("利用規約に同意して、登録・ログインする")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfH6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{ icon: 'bubble_chart', title: 'サインイン', href: '/#/signin' }, { icon: 'bubble_chart', title: 'Inspireaaaa', href: '/#/test' }, { icon: 'bubble_chart', title: '大会情報', href: '/#/tournament' }, { icon: 'bubble_chart', title: 'Inspire2', href: '/' }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'ACTIVE HOOP'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    user: 'user'
  }))
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2112a309_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("vaW/");
function injectStyle (ssrContext) {
  __webpack_require__("SszN")
  __webpack_require__("JNHC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2112a309"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2112a309_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ypDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("下の「エントリーをキャンセルする」ボタンを押してエントリーいただくことで、お客様は当サイトのプライバシー規約及び利用規約に同意の上、大会にエントリーされたことになります。\n  ")]),_vm._v(" "),_c('v-btn',{attrs:{"block":""},on:{"click":_vm.cancel}},[_vm._v("エントリーをキャンセルする")]),_vm._v(" "),_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',[_c('h4',{staticClass:"headline"},[_vm._v("エントリー内容")])])]),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("event")]),_vm._v("\n"+_vm._s(_vm.item.startTime))],1),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("location_on")]),_vm._v("\n"+_vm._s(_vm.item.location)+"\n")],1),_vm._v(" "),_c('p',[_vm._v("\nチーム\n"),_c('v-select',{attrs:{"items":_vm.items,"label":"Select","single-line":"","item-text":"label","item-value":"value","return-object":""},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})],1),_vm._v(" "),_c('p',[_c('v-icon',[_vm._v("payment")]),_vm._v("\n参加費 ¥ "+_vm._s(_vm.item.entryFee)+"/チーム\n")],1),_vm._v(" "),_c('v-divider'),_vm._v("\nご請求額："),_c('span',{staticClass:"price"},[_vm._v("¥ "+_vm._s(this.item.entryFee))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.payMethod),callback:function ($$v) {_vm.payMethod=$$v},expression:"payMethod"}},[_c('v-radio',{attrs:{"label":"現地払い","value":"ON-SITE"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"block":"","error":""},on:{"click":_vm.cancel}},[_vm._v("エントリーを確定する")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"headline mt-4"},[_vm._v("支払い方法")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.13d177b19684ebf0f0b3.js